<svg width="100%" height="100%" viewBox="0 0 65 64" xmlns="http://www.w3.org/2000/svg">
	<g transform="matrix(-1,0,0,1,64.001,0)">
		<path
			d="M23.001,54.5C22.617,54.5 22.233,54.354 21.94,54.061C21.354,53.475 21.354,52.526 21.94,51.94L41.88,32L21.94,12.061C21.354,11.475 21.354,10.526 21.94,9.94C22.526,9.354 23.475,9.354 24.061,9.94L45.061,30.94C45.647,31.526 45.647,32.475 45.061,33.061L24.061,54.061C23.769,54.354 23.385,54.5 23.001,54.5Z"
			style="fill:rgb(38,38,38);fill-rule:nonzero;"
		/>
	</g>
</svg>
